// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2FYL0","errorLogs":"styles_errorLogs__15qLc"};